import React, { useMemo } from "react";
import { ChartData } from "chart.js";
import { Box, Card, CardContent, CardHeader, Divider, useTheme } from "@mui/material";
import { Client } from "../../apis/clients";
import { useGetRequestByTypesQuery } from "../../apis/requests";
import PieChart from "../Chart/PieChart";

interface Props {
  client: Client;
}

const RequestByTypes = ({ client }: Props) => {
  const theme = useTheme();
  const { data: requests } = useGetRequestByTypesQuery(client.id);

  const chartData: ChartData<"pie"> = useMemo(() => {
    const labels: string[] = [];
    const data: number[] = [];

    requests?.data.forEach((request) => {
      labels.push(request.type);
      data.push(request.count);
    });

    const { primary, secondary, error } = theme.palette;

    return {
      labels,
      datasets: [{ data, backgroundColor: [primary.main, secondary.main, error.main] }],
    };
  }, [requests, theme]);

  return (
    <Card>
      <CardHeader title="Requests by types" subheader="Last 30 days" />
      <Divider />
      <CardContent>
        <Box width={300}>
          <PieChart
            data={chartData}
            options={{ responsive: true, plugins: { legend: { position: "right" } } }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default RequestByTypes;
